import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { clientRoute } from '../route';

export const clientOverviewRoute = createRoute({
	path: '/overview',
	getParentRoute: () => clientRoute,
	component: lazyRouteComponent(
		() => import('./ClientOverviewPage'),
		'ClientOverviewPage',
	),
});
